import React from 'react';
import TextAnswer from './TextAnswer';
import { DateAnswer } from '../../types/Answer';
import ReactHtmlParser from 'react-html-parser';

interface Props {
  label: string;
  answer?: DateAnswer;
}

const DateTextAnswer = ({ label, answer }: Props) => <TextAnswer question={ReactHtmlParser(label)} answer={answer} />;

export default DateTextAnswer;
